var styles = {"carousel-container":"styles_carousel-container__3yZ-f inline-block","carouselContainer":"styles_carousel-container__3yZ-f inline-block","carousel":"styles_carousel__2mD-f flex"};

export default styles;
//# sourceMappingURL=styles.css.js.map
